import {useParams} from 'react-router-dom';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import {TableSkeleton} from '@/components/Table/TableSkeleton';
import UserTable from '@/screens/User/List/UserTable';
import type {AdminAfriexPerson} from '@/types';

import TierUserUpdateButton from './TierUserUpdateButton';
import useTierUserList from './useTierUserList';

const TierUserList = () => {
  const params = useParams();
  const tierId = params?.tierId || '';
  const {isLoading, fetchList, total, list} = useTierUserList(tierId);

  return (
    <main className="my-5">
      <PermissionsProvider
        permission={AfriexAdminPermission.ReferralTierManage}
      >
        <div className="flex justify-end">
          <TierUserUpdateButton tierId={tierId} />
        </div>
      </PermissionsProvider>

      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <UserTable
            items={list as AdminAfriexPerson[]}
            extraRow={(user) => (
              <PermissionsProvider
                permission={AfriexAdminPermission.ReferralTierManage}
              >
                <div className="w-full flex justify-end mb-3">
                  <TierUserUpdateButton tierId={tierId} userId={user?.id} />
                </div>
              </PermissionsProvider>
            )}
          />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};

export default TierUserList;
